/* eslint-disable no-unused-vars */
import React, { createRef, useEffect, useState } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { bindActionCreators } from "redux";
import Dropzone from "react-dropzone";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import _, { keyBy, has } from "lodash";
import axios from "axios";
import { Button, Card, CardBody, Col, Row, Alert } from "reactstrap";
import Select from "react-select";
import moment from "moment";
import { ToastContainer, toast } from "react-toastify";
import { SingleDatePicker } from "react-dates";
import * as i18nActions from "../../../../redux/actions/i18nActions";
import * as deviceActions from "../../../../redux/actions/deviceActions";
import * as organizationsActions from "../../../../redux/actions/organizationsActions";
import * as ordersActions from "../../../../redux/actions/ordersActions";
import * as InstallationsActions from "../../../../redux/actions/InstallationsActions";
import API_ENDPOINTS from "../../../../configs/API_ENDPOINTS";
import { translate } from "../../../../utils/i18n";
import { BlockPlaceholder } from "../../../Components";
import DeleteDeviceFileAttachments from "../../../Components/orders/Installations/DeleteDeviceFileAttachments";
import DeviceFiltering from "../../../Components/Device/DeviceFiltering";
import "react-dates/lib/css/_datepicker.css";
import "react-toastify/dist/ReactToastify.css";
import "../../../Components/SelectDateComp.css";

const AddOrEditServicesOrder = (props) => {
  const [serviceCenter, setServiceCenter] = useState({});
  const [technician, setTechnician] = useState({});
  const [note, setNote] = useState("");
  const [isFetchingSelectedServiceOrderAttachments, setIsFetchingSelectedServiceOrderAttachments] = useState(true);
  const [attachmentsList, setAttachmentsList] = useState([]);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [isOpenDeleteModal, setIsOpenDeleteModal] = useState(false);
  const [selectedFileToDelete, setSelectedFileToDelete] = useState({});
  const [isEditMode, setIsEditMode] = useState(false);
  const [dueDate, setDueDate] = useState(moment(new Date()).add(1, "days").endOf("day"));
  const [focusedInput, setfocusedInput] = useState(false);
  const [isDeviceHasOtherOrders, setIsDeviceHasOtherOrders] = useState(false);
  const [filteredDevices, setFilteredDevices] = useState([]);
  const [deviceTypeList, setDeviceTypeList] = useState([]);
  const [deviceModelList, setDeviceModelList] = useState([]);

  const dropzoneRef = createRef();

  useEffect(() => {
    if (props.deviceId != undefined) {
      onSelectDevice(props.deviceId);
    } else {
      props.FetchAllOrganizationsList();

      const getList = async () => {
        try {
          const response = await axios.get(`${API_ENDPOINTS.DEVICETYPE_CATEGORIES}/getAll`);
          const { data } = response;
          setDeviceModelList(data[0].deviceModelName);
          setDeviceTypeList(data[0].deviceTypeName);
        } catch (error) {
          console.error(error);
        }
      };

      getList();
    }
  }, []);

  const toggle = () => setIsOpenDeleteModal(!isOpenDeleteModal);

  const handleOnDrop = (acceptedFiles) => {
    setSelectedFiles(
      _(selectedFiles) // start sequence
        .keyBy("name") // create a dictionary of the 1st array
        .merge(keyBy(acceptedFiles, "name")) // create a dictionary of the 2nd array, and merge it to the 1st
        .values() // turn the combined dictionary to array
        .value()
    );
  };
  const handleOnFileDialogCancel = () => {};
  const handleOnDropAccepted = (e) => {};
  const handleOnDropRejected = (e) => {};
  const formatSizeUnits = (bytes) => {
    if (bytes >= 1073741824) {
      bytes = (bytes / 1073741824).toFixed(2) + " GB";
    } else if (bytes >= 1048576) {
      bytes = (bytes / 1048576).toFixed(2) + " MB";
    } else if (bytes >= 1024) {
      bytes = (bytes / 1024).toFixed(2) + " KB";
    } else if (bytes > 1) {
      bytes = bytes + " bytes";
    } else if (bytes === 1) {
      bytes = bytes + " byte";
    } else {
      bytes = "0 byte";
    }
    return bytes;
  };

  const removeFile = (selectedFile) => {
    setSelectedFiles(selectedFiles.filter((f) => f.name !== selectedFile.name));
  };

  useEffect(() => {
    setIsEditMode(props.match.params.order_id !== undefined);
    if (props.match.params.order_id) {
      props.fetchServiceOrderDetails(props.match.params.order_id);
    } else if (!props.deviceId) {
      props.SetSelectedDeviceInfo({});
      props.getSelectedDeviceInfo();
    }
    return () => {};
  }, []);

  useEffect(() => {
    if (props.selectedDeviceInfo && "_id" in props.selectedDeviceInfo) {
      if (props.serviceOrdersList.length > 0) {
        setIsDeviceHasOtherOrders(
          !!props.serviceOrdersList.find(
            (order) =>
              "device" in order &&
              order.device &&
              order.device._id === props.selectedDeviceInfo._id &&
              (order.status.slug !== "sos_completed" || order.status.slug !== "sos_archived")
          )
        );
      }
      if (!props.isFetchingServiceCentersList && props.serviceCentersList.length === 0) {
        props.fetchAllServiceCenters();
      }
    }
    return () => {};
  }, [props.selectedDeviceInfo]);

  useEffect(() => {
    if ("_id" in serviceCenter) props.getServiceCenterTechnicians(serviceCenter._id);
    return () => {};
  }, [serviceCenter]);

  const fetchDeviceServiceOrderAttachmentsList = () => {
    props
      .getDeviceServiceOrderAttachmentsList(props.selectedServiceOrderDetails)
      .then((res) => {
        if ("request" in res && res.request.status !== "200") {
          setIsFetchingSelectedServiceOrderAttachments(false);
        } else {
          setAttachmentsList(res);
          setIsFetchingSelectedServiceOrderAttachments(false);
        }
      })
      .catch((e) => setIsFetchingSelectedServiceOrderAttachments(false));
  };

  useEffect(() => {
    if (
      props.selectedServiceOrderDetails &&
      "_id" in props.selectedServiceOrderDetails &&
      props.match.params.order_id !== undefined
    ) {
      onSelectDevice(props.selectedServiceOrderDetails.device);
      props.SetSelectedDeviceInfo(props.selectedServiceOrderDetails.device);
      if (props.selectedServiceOrderDetails.attachments.length > 0) {
        fetchDeviceServiceOrderAttachmentsList();
      }
      props.SetSelectedDeviceInfo(props.selectedServiceOrderDetails.device);

      setServiceCenter(props.selectedServiceOrderDetails.service_center);
      setTechnician(
        has(props.selectedServiceOrderDetails.technician, "name") ? props.selectedServiceOrderDetails.technician : {}
      );
      setNote(props.selectedServiceOrderDetails.notes);
      setDueDate(moment(props.selectedServiceOrderDetails.dueDate || new Date()).endOf("day"));
    } else if (isEditMode && props.match.params.order_id === undefined) {
      props.history.push("/orders/service-orders");
    }
  }, [props.selectedServiceOrderDetails]);

  const onSelectDevice = (v) => {
    if (v && "_id" in v) props.getSelectedDeviceInfo(v._id);
  };

  const handleUploadFilesAndExit = (servicesOrderId) => {
    const attachmentsData = new FormData();
    for (let i = 0; i < selectedFiles.length; i++) {
      attachmentsData.append("file", selectedFiles[i]);
    }
    if (selectedFiles.length > 0) {
      props.addServicesOrderAttachments(servicesOrderId, attachmentsData);
    }
  };

  const onSave = () => {
    if (isEditMode) {
      props
        .editServicesOrderData({
          _id: props.match.params.order_id,
          device: props.selectedDeviceInfo._id,
          technician: technician._id ?? "",
          owner: props.selectedDeviceInfo.owner._id,
          service_center: serviceCenter._id,
          dueDate: moment(dueDate).endOf("day"),
          notes: note,
        })
        .then((res) => {
          if ("_id" in res) {
            handleUploadFilesAndExit(res._id);
          }
        });
    } else {
      const attachmentsData = new FormData();
      for (let i = 0; i < selectedFiles.length; i++) {
        attachmentsData.append("file", selectedFiles[i]);
      }
      props
        .AddOrEditServicesOrder({
          device: props.selectedDeviceInfo._id,
          technician: technician._id ?? "",
          owner: props.selectedDeviceInfo.owner._id,
          service_center: serviceCenter._id,
          note: note,
          dueDate: moment(dueDate).endOf("day"),
        })
        .then((res) => {
          if ("_id" in res) {
            handleUploadFilesAndExit(res._id);
          }
          //Display toast notification of success
          toast.success("Installation order created successfully");
          onClear();
        })
        .catch((err) => {
          //Display toast notification of error
          toast.error("Error creating installation order");
        });
    }
  };

  const onCancel = () => {
    if (props.history.location.pathname === "/monitoring" || typeof props.onServiceClick === "function") {
      return props.onServiceClick();
    }
    props.getSelectedDeviceInfo();
    props.SetSelectedDeviceInfo({});
    props.history.goBack();
  };

  const onClear = () => {
    if (props.history.location.pathname === "/monitoring" || typeof props.onServiceClick === "function") {
      return props.onServiceClick();
    }
    props.getSelectedDeviceInfo();
    props.SetSelectedDeviceInfo({});
  };

  const onSubmitDeleteAttachedFile = () => {
    props.deleteServiceOrderAttachments(props.selectedServiceOrderDetails, selectedFileToDelete).then(() => {
      setIsFetchingSelectedServiceOrderAttachments(true);
      toggle();
      fetchDeviceServiceOrderAttachmentsList();
    });
  };
  const SingleDatePickerOnfigs = {
    small: true,
    regular: true,
    showDefaultInputIcon: true,
    isOutsideRange: (day) => day.diff(moment()) < 0,
    enableOutsideDays: true,
    reopenPickerOnClearDate: true,
    numberOfMonths: 1,
    date: dueDate,
    onDateChange: (date) => setDueDate(moment(new Date(date)).endOf("day")),
    focused: focusedInput,
    onFocusChange: ({ focused }) => setfocusedInput(focused),
    id: "orderDueDate",
  };

  const onChangeOrgs = async (orgs) => {
    let orgsToString = orgs.join(",");

    try {
      const { data } = await axios.get(`${API_ENDPOINTS.DEVICETYPE_CATEGORIES}/getAll?orgs=${orgsToString}`);
      setDeviceModelList(data[0].deviceModelName);
      setDeviceTypeList(data[0].deviceTypeName);
    } catch (error) {
      console.error(error);
    }
  };

  const onDevicesFiltering = async (url) => {
    if (url.length === 0) {
      return;
    }

    try {
      const response = await axios.get(url);

      // call props method to send back the filtered data:
      const { data, page, perPage, total, lastPage } = response.data;

      setFilteredDevices(data || []);
    } catch (error) {
      console.log("error in fetching devices ", error);
    }
  };

  return (
    <React.Fragment>
      <ToastContainer position="top-right" autoClose={5000} style={{ zIndex: 999, marginTop: "40px" }} />
      <div className="row">
        <Card className="col-12">
          {props.isFetchingSelectedServiceOrderDetails ? (
            <BlockPlaceholder height="300" />
          ) : (
            <CardBody className="px-0 pb-0">
              {props.isAddingNewServiceOrder ? (
                <div className="d-flex justify-content-center align-items-center" style={{ height: "400px" }}>
                  <h3 className="text-info">{translate(isEditMode ? "EditingServiceOrderMsg" : "AddingNewServiceOrderMsg")}</h3>
                </div>
              ) : props.isAddingNewServiceOrder || props.isAddingServiceOrderAttachments ? (
                <div className="d-flex justify-content-center align-items-center" style={{ height: "400px" }}>
                  <h3 className="text-info">{translate("AddingServiceOrderAttachmentsMsg")}</h3>
                </div>
              ) : (
                <>
                  <div className="d-flex flex-column flex-md-row">
                    <div className="flex-grow-1">
                      <h3>{isEditMode ? translate("editServicesOrderTitle") : translate("newServicesOrderTitle")}</h3>
                    </div>
                    <div className="d-flex flex-row">
                      <Button
                        color="success"
                        className="px-4"
                        block
                        onClick={onSave}
                        disabled={!serviceCenter?._id || !technician?._id}
                      >
                        {translate("save")}
                      </Button>

                      <div className="p-0 pl-3">
                        <Button color="danger" outline className="px-4" block onClick={onCancel}>
                          {translate("cancel")}
                        </Button>
                      </div>
                    </div>
                  </div>
                  <div className="mt-3 mb-2 row">
                    <div
                      className={`col-12 col-md-12 ${
                        isDeviceHasOtherOrders ? " col-md-6 col-lg-6 " : " col-md-12 col-lg-12 "
                      } form-group`}
                    >
                      {/* {!isEditMode && (
                      )} */}
                      {isEditMode ? (
                        <p>{props.selectedDeviceInfo && "name" in props.selectedDeviceInfo && props.selectedDeviceInfo.name}</p>
                      ) : (
                        <>
                          {window.location.pathname === "/monitoring" || props.deviceId ? (
                            <></>
                          ) : (
                            <DeviceFiltering
                              enableUrlPersistence={false}
                              onChangeOrg={onChangeOrgs}
                              organizations={props.organizations}
                              deviceTypeCategories={deviceTypeList}
                              deviceModels={deviceModelList}
                              devices={props.devices}
                              onDevicesFiltering={onDevicesFiltering}
                            ></DeviceFiltering>
                          )}

                          <label htmlFor="orderDevice" className="col-form-label text-muted">
                            {translate(isEditMode ? "form.name" : "form.devices")}
                          </label>
                          <Select
                            id="orderDevice"
                            name="orderDevice"
                            placeholder={translate("selectPlaceHolder")}
                            value={props.selectedDeviceInfo || {}}
                            onChange={(v) => {
                              onSelectDevice(v);
                            }}
                            isMulti={false}
                            options={filteredDevices}
                            getOptionLabel={(o) =>
                              `${o.device ? o.device : ""} ${o.name ? " - " + o.name : ""} ${
                                o.serialNumber ? " - " + o.serialNumber : ""
                              }`
                            }
                            getOptionValue={(o) => o}
                            className="basic-multi-select"
                            classNamePrefix="select"
                            isLoading={props.isFetchingDevicesList}
                            isDisabled={!props.deviceId ? props.isFetchingDevicesList : true}
                          />
                        </>
                      )}
                    </div>

                    {props.selectedDeviceInfo && "_id" in props.selectedDeviceInfo && (
                      <>
                        {!isEditMode && isDeviceHasOtherOrders && (
                          <div className="col-12 col-md-6 col-lg-6 d-flex flex-column justify-content-end">
                            <Alert color="warning" className="mt-2">
                              {translate("orderDeviceHasOtherOrders")}
                            </Alert>
                          </div>
                        )}
                        <div className="col-12 col-md-6 col-lg-6 d-flex flex-column">
                          <label htmlFor="device" className="col-form-label text-muted">
                            {translate("form.owner")}
                          </label>
                          <p>{props.selectedDeviceInfo.owner?.name ?? ""}</p>
                        </div>
                        <div className="col-12 col-md-6 col-lg-6 d-flex flex-column">
                          <label htmlFor="device" className="col-form-label text-muted">
                            {translate("form.device_type")}
                          </label>
                          <p>{translate(`${props.selectedDeviceInfo.device_model.deviceTypeCategory.slug}`)}</p>
                        </div>
                        <div className="col-12 col-md-6 col-lg-6 d-flex flex-column">
                          <label htmlFor="device" className="col-form-label text-muted">
                            {translate("form.device_model")}
                          </label>
                          <p>{props.selectedDeviceInfo.device_model.title}</p>
                        </div>
                        <div className="col-12 col-md-6 col-lg-6 d-flex flex-column">
                          <label htmlFor="device" className="col-form-label text-muted">
                            {translate("form.device")}
                          </label>
                          <p>{props.selectedDeviceInfo.device}</p>
                        </div>
                        <div className="col-12 col-md-6 col-lg-6 d-flex flex-column">
                          <label htmlFor="device" className="col-form-label text-muted">
                            {translate("form.created_at")}
                          </label>
                          <p>{moment.utc(props.selectedDeviceInfo.created_at).local().format("YYYY-MM-DD HH:mm:ss")}</p>
                        </div>
                        <div className="col-12 col-md-6 col-lg-6 d-flex flex-column">
                          <label htmlFor="device" className="col-form-label text-muted">
                            {translate("form.lastSeenAt")}
                          </label>
                          <p>{moment.utc(props.selectedDeviceInfo.lastSeenAt).local().format("YYYY-MM-DD HH:mm:ss")}</p>
                        </div>

                        <div
                          className={`col-12 ${
                            "_id" in serviceCenter ? " col-md-6 col-lg-6 " : " col-md-12 col-lg-12 "
                          } form-group`}
                        >
                          <label htmlFor="orderServiceCenter" className="col-form-label text-muted">
                            {translate("form.orderServiceCenter")}
                          </label>
                          <Select
                            id="orderServiceCenter"
                            name="orderServiceCenter"
                            placeholder={translate("selectPlaceHolder")}
                            value={serviceCenter}
                            onChange={(v) => {
                              setServiceCenter(v);
                              setTechnician({});
                            }}
                            isMulti={false}
                            options={props.serviceCentersList}
                            getOptionLabel={(option) => option.name}
                            getOptionValue={(option) => option}
                            className="basic-multi-select"
                            classNamePrefix="select"
                            isLoading={props.isFetchingServiceCentersList}
                            isDisabled={props.isFetchingServiceCentersList}
                          />
                        </div>
                        {"_id" in serviceCenter && (
                          <div className={`col-12 col-md-6 col-lg-6 form-group`}>
                            <label htmlFor="orderTechnician" className="col-form-label text-muted">
                              {translate("form.orderTechnician")}
                            </label>
                            <Select
                              id="orderTechnician"
                              name="orderTechnician"
                              placeholder={translate("selectPlaceHolder")}
                              value={technician}
                              onChange={(v) => {
                                setTechnician(v);
                              }}
                              isMulti={false}
                              options={props.selectedServiceCenterTechniciansList}
                              getOptionLabel={(option) => option.name}
                              getOptionValue={(option) => option}
                              className="basic-multi-select"
                              classNamePrefix="select"
                              isLoading={props.isFetchingServiceCenterTechnicians}
                              isDisabled={props.isFetchingServiceCenterTechnicians}
                            />
                          </div>
                        )}
                        <div className="col-12 col-lg-6 col-md-6 form-group newInstallationSingleDatePicker">
                          <label htmlFor="orderDueDate" className="d-block col-form-label text-muted">
                            {translate("form.orderDueDate")}
                          </label>
                          <SingleDatePicker {...SingleDatePickerOnfigs} />
                        </div>
                        <div className={`col-12 col-md-6 col-lg-6 form-group`}>
                          <label htmlFor="orderNote" className="col-form-label text-muted">
                            {translate("orderNotes")}
                          </label>
                          <div>
                            <textarea
                              name="notes"
                              value={note}
                              onChange={(e) => {
                                setNote(e.target.value);
                              }}
                              className="form-control"
                            ></textarea>
                          </div>
                        </div>
                      </>
                    )}
                    {isEditMode && props.selectedServiceOrderDetails.attachments.length > 0 && (
                      <div className="col-12">
                        {isFetchingSelectedServiceOrderAttachments ? (
                          <BlockPlaceholder height="100" />
                        ) : (
                          <Row
                            style={{
                              maxHeight: "350px",
                              // overflowY: attachmentsList.length ? "scroll" : "auto",
                              overflowY: "auto",
                              marginBottom: "1.2rem",
                            }}
                          >
                            {attachmentsList.length ? (
                              attachmentsList.map((file) => (
                                <Col xs={12} lg={12} key={file._id} className="my-2">
                                  <div className="card w-100 h-100">
                                    <div className={`card-body d-flex justify-content-between align-items-center flex-column}`}>
                                      <div className="w-100  pb-3 pb-md-0">
                                        <p className="lead m-0 pm-3 pr-2">{file.name}</p>
                                        <p className="m-0 text-muted">{moment(file.created_at).format("YYYY-MM-DD HH:mm A")}</p>
                                      </div>
                                      <div className=" flex-nowrap d-flex justify-content-between align-items-center ">
                                        <Button
                                          outline
                                          color="danger"
                                          onClick={() => {
                                            setSelectedFileToDelete(file);
                                            toggle();
                                          }}
                                        >
                                          <FontAwesomeIcon icon="trash" />
                                        </Button>
                                        <a
                                          href={file.url}
                                          className={` ml-3 btn ${file.url ? "btn-primary " : "btn-warning "}`}
                                          target="_blank"
                                          title={file.url ? "Download" : "Corrupted file"}
                                          download={file.name}
                                        >
                                          <FontAwesomeIcon icon={file.url ? "download" : "exclamation-triangle"} />
                                        </a>
                                      </div>
                                    </div>
                                  </div>
                                </Col>
                              ))
                            ) : (
                              <p className="w-100 h2 font-weight-light text-center my-4 text-muted">
                                {selectedFiles && selectedFiles.length <= 0 && translate("noAttatchments")}
                              </p>
                            )}
                            <DeleteDeviceFileAttachments
                              isOpenDeleteModal={isOpenDeleteModal}
                              toggle={toggle}
                              file={selectedFileToDelete}
                              device={props.selectedServiceOrderDetails.device}
                              onSubmitDelete={onSubmitDeleteAttachedFile}
                            />
                          </Row>
                        )}
                      </div>
                    )}
                    {technician?._id && (
                      <div className="col-12">
                        <Dropzone
                          ref={dropzoneRef}
                          onDrop={(acceptedFiles) => handleOnDrop(acceptedFiles)}
                          onFileDialogCancel={(e) => handleOnFileDialogCancel(e)}
                          onDropAccepted={(e) => handleOnDropAccepted(e)}
                          onDropRejected={(e) => handleOnDropRejected(e)}
                        >
                          {({ getRootProps, getInputProps }) => (
                            <section>
                              <div {...getRootProps()}>
                                <div className="card btn btn-outline-primary" style={{ border: "1px dashed" }}>
                                  <p className="lead text-center my-3 card-body ">
                                    {translate("selectFileMsg")}
                                    <FontAwesomeIcon icon="upload" className="ml-2" />
                                  </p>
                                  <input {...getInputProps({ multiple: true })} />
                                </div>
                              </div>
                            </section>
                          )}
                        </Dropzone>
                        <div className="row">
                          {selectedFiles.map((selectedFile, index) => (
                            <div className={`col-12 col-md-12 ${selectedFiles.length > 1 ? "col-lg-6" : "col-lg-12"}`}>
                              <div className="card" key={selectedFile.lastModified}>
                                <div className="card-body">
                                  <div
                                    className={`d-flex justify-content-between flex-column-reverse  ${
                                      props.isSmall ? "" : "flex-md-row"
                                    }`}
                                  >
                                    <span className="lead py-3">
                                      {selectedFile.path}
                                      <span className="lead text-muted"> ({formatSizeUnits(selectedFile.size)})</span>
                                    </span>
                                    <div className=" flex-nowrap d-flex justify-content-between align-items-center ">
                                      <Button
                                        outline
                                        color="danger"
                                        className="ml-3"
                                        onClick={() => {
                                          removeFile(selectedFile);
                                        }}
                                      >
                                        <FontAwesomeIcon icon="times" />
                                      </Button>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          ))}
                        </div>
                      </div>
                    )}
                  </div>
                </>
              )}
            </CardBody>
          )}
        </Card>
      </div>
    </React.Fragment>
  );
};
const mapStateToProps = (state) => ({
  devices: state.devicesReducer.devices,
  deviceModels: state.devicesReducer.devicesModelsList,
  deviceTypeCategories: state.devicesReducer.deviceTypeCategories,
  organizations: state.organizationsReducer.organizations,
  language: state.i18nReducer.language,
  devices: state.devicesReducer.devices,
  maniView: state.servicesReducer.maniView,
  serviceCentersList: state.servicesReducer.serviceCentersList,
  selectedServiceCenterTechniciansList: state.servicesReducer.selectedServiceCenterTechniciansList,
  isFetchingServiceCenterTechnicians: state.servicesReducer.isFetchingServiceCenterTechnicians,
  isFetchingServiceCentersList: state.servicesReducer.isFetchingServiceCentersList,
  isFetchingDevicesList: state.devicesReducer.isFetchingDevicesList,
  selectedDeviceInfo: state.devicesReducer.selectedDeviceInfo,
  isAddingNewServiceOrder: state.ServiceOrdersReducer.isAddingNewServiceOrder,
  isAddingServiceOrderAttachments: state.ServiceOrdersReducer.isAddingServiceOrderAttachments,
  isFetchingSelectedServiceOrderDetails: state.ServiceOrdersReducer.isFetchingSelectedServiceOrderDetails,
  selectedServiceOrderDetails: state.ServiceOrdersReducer.selectedServiceOrderDetails,
  isFetchingServiceOrdersList: state.ServiceOrdersReducer.isFetchingServiceOrdersList,
  serviceOrdersList: state.ServiceOrdersReducer.serviceOrdersList,
});

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      ...deviceActions,
      ...ordersActions,
      ...organizationsActions,
      ...InstallationsActions,

      ...i18nActions,
    },
    dispatch
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(AddOrEditServicesOrder));
